import { render } from "./SummaryPanel.vue?vue&type=template&id=b4fe9e84"
import script from "./SummaryPanel.vue?vue&type=script&lang=js"
export * from "./SummaryPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__